export enum PaymentBrand {
  NONE = "NONE",
  MADA = "MADA",
  VISA = "VISA",
  BANK_TRANSFER = "BANK_TRANSFER",
}
export interface ICheckoutRequest {
  paymentBrand: PaymentBrand;
  contractId: string;
  amount: string | number;
  currency?: string | null;
  customerType: string;
  paymentType: string;
  beneficiaryId: string;
  beneficiaryName: string;
  payeeId: string;
  payeeName: string;
}

export interface ICheckoutResponse {
  data: {
    httpStatus: string;
    id: string;
    paymentBrand: string;
    result: { code: string; description: string };
  };
  status: number;
  successful: boolean;
  timestamp: Date;
}

export interface ICashoutRequest {
  referenceTransactionId: string;
  amount: number;
  assignedBeneficiaryId?: string;
  assignedBeneficiaryName?: string;
  domainId?: string;
  gatewayPaymentId?: string;
  transactionDate?: string;
}

interface BankTransferPaymentResponse {
  docs: string[];
}

export interface ICashoutResponse {
  data: {
    transactionId: string;
    referenceTransactionId: string;
    transactionType: string;
    status: string;
    domainId: string;
    domainType: string;
    connectorType: string;
    gatewayPaymentId: string;
    paymentMethod: string;
    paymentBrand: string;
    currency: string;
    amount: number;
    fees: number;
    beneficiaryId: string;
    beneficiaryName: string;
    fromUserId: string;
    fromUserName: string;
    requesterId: string;
    bankTransferPaymentResponse: BankTransferPaymentResponse;
    statusDescription: string;
  };
  status: number;
  successful: boolean;
  timestamp: Date;
}

export interface BankResponseData {
  id: number;
  iban: string;
  currency: string;
  beneficiaryName: string;
  bank: {
    id: number;
    arabicName: string;
    englishName: string;
    abbreviation: string;
    swiftCode: string;
  };
  selectedBank: {
    id: number;
    arabicName: string;
    englishName: string;
    abbreviation: string;
    swiftCode: string;
  };
}

export interface IBankResponse {
  data: BankResponseData;
}

export interface IBankTransferBody {
  domainId: string;
  parentDomainId?: string;
  domainType: string;
  paymentType: string;
  paymentBrand: PaymentBrand;
  currency: string;
  connector:
    | "MOYASAR"
    | "HYPER_PAY"
    | "TABBY"
    | "MANUAL_BANK_TRANSFER"
    | "NEO"
    | "TAMARA";
  amount: number;
  beneficiaryId: string;
  beneficiaryName: string;
  fromUserId: number;
  fromUserName: string;
  version: number;
  bankTransferPaymentInfo?: {
    docs: string[];
  };
  gatewayPaymentId?: string;
}

export interface IBankTransferResponse {
  status: 200;
  data: {
    transactionId: string;
    referenceTransactionId: string;
    domainId: string;
    domainType: string;
    status: string;
    statusDescription: string;
  };
}
